var React = require('react');

function Client (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.419 5.498c2.727-.64 2.727-2.36 2.727-3.502v-.1a.563.563 0 00-.565-.565h-.906c.038-.44.063-.879.063-1.331H1.445c0 .452.025.904.063 1.331H.565A.562.562 0 000 1.895v.1C0 3.151 0 4.87 2.764 5.511c.591.992 1.332 1.682 2.161 1.921v2.573h-1.62a.622.622 0 00-.628.628c0 .351.276.628.628.628h4.398a.622.622 0 00.628-.628.622.622 0 00-.628-.628h-1.52V7.444c.854-.226 1.633-.929 2.236-1.946zm1.583-3.038c-.025.678-.163 1.243-.942 1.632.175-.502.326-1.054.439-1.632h.503zm-8.871 0h.54c.113.59.264 1.142.44 1.644-.817-.388-.955-.966-.98-1.644zm1.621-1.217h5.654c-.302 2.95-1.621 5.021-2.827 5.021-1.194 0-2.526-2.071-2.827-5.021z"}));
}

Client.defaultProps = {"width":"11.145","height":"11.26","viewBox":"0 0 11.145 11.26"};

module.exports = Client;

Client.default = Client;
